
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TableReservationSettingsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EX_TRSV_Settings"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultDuration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tablePlacementMode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"touchKeyboardAutoOpen"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"presetButtonSize"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"noteTags"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"onlineEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"serviceTimes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weekday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"to"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"closedDates"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slotInterval"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leadTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxAdvanceDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minPartySize"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxPartySize"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"autoConfirm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"guestConfirmationEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notificationRecipients"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"onlineHint"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":443}};
    doc.loc.source = {"body":"fragment TableReservationSettingsFields on EX_TRSV_Settings {\n    id\n    defaultDuration\n    tablePlacementMode\n    touchKeyboardAutoOpen\n    presetButtonSize\n    noteTags\n    onlineEnabled\n    serviceTimes {\n        weekday\n        from\n        to\n    }\n    closedDates\n    slotInterval\n    leadTime\n    maxAdvanceDays\n    minPartySize\n    maxPartySize\n    autoConfirm\n    guestConfirmationEnabled\n    notificationRecipients\n    onlineHint\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["TableReservationSettingsFields"] = oneQuery(doc, "TableReservationSettingsFields");
        
